<template>
  <div>
    <div class="card shadow">
      <div class="card-header bg-transparent">
        <div>
          <h3 class="mb-0">
            Medecin Contrôle Board
          </h3>
          <!-- <TaskCreate /> -->
        </div>
      </div>

      <div class="card-body">
        <b-container>
          <b-col>
            <router-link :to="{ name: 'create-activite-controle'}">
            <b-button variant="outline-success">
              <i class="fas fa-plus"></i>
              {{ $t("message.add") }} 
            </b-button>
          </router-link>
          </b-col>
          <b-row>
             <div class="w-100 p-3">
                    <b-container>
                        <b-row>
                            <b-col col sm="12">
                    
                            </b-col>
                        </b-row>
                    </b-container>
              </div>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from 'lodash';

export default {
  name: 'app',
  computed: {
            ...mapGetters([
                "file",
                'hasAdminRole',
                'hasMedecinControleRole',
                'hasPatientRole',
                'hasPraticienRole',
                'hasSouscripteurRole',
                'hasGestionnaireRole',"userInstitutions"
            ]),

            can: function () {
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole;
            },

            pecColumns: function () {
                return [
                    {
                        label: this.$i18n.tc('message.institution'),
                        field: 'institution',
                    },
                    {
                        label: this.$i18n.tc('message.nomPatient'),
                        field: 'comptable',
                    }
                ];
            },

            pecRows:function(){
                let cArray = [];

                _.forEach(this.pecsList,function (pec) {
                    _.forEach(pec.comptables,function (comptable) {
                        let user = comptable.user;
                        if(!_.isNull(user)){
                            let prenom = (user.prenom == null) ? '' : user.prenom;
                            let nomComplet= (user.nom).toUpperCase() + " " +prenom.charAt(0).toUpperCase() + prenom.substring(1);
                            cArray.push({
                              pec:comptable.name,
                              comptable:nomComplet,
                              slug:comptable.slug});
                        }
                        

                        
                    })
                })
                return cArray;
            }
  },
  data(){
      return {
          paginationOptions: {
              enabled: true,
              mode: 'records',
              perPageDropdown: [3, 6, 10]
          },
      }
  },
  methods:{
      getUserInstitutions() {
          let args = {
              offset: this.offset,
              limit: this.limit
          };

          this.$store.dispatch('getUserInstitutions', { args : args });
      },
      getPecActivites() {
        let args = {
            offset: this.offset,
            limit: this.limit
        };

        this.$store.dispatch('getPecActivites', { args : args });
      },

      onComptableClick(params){
          this.$router.push({ name: 'accountant', params: { accountant: params.row.slug } });

      }
  },
  mounted() {
      //this.getUserInstitutions();
  }
}
</script>
